const secrets = {
  geomarkApiKey: 'KEY_GEOMARK_API_KEY',
  geomarkGmapsId: 'KEY_GEOMARK_GMAPS_ID',
  geomarkGmapsKey: 'KEY_GEOMARK_GMAPS_KEY',
  mixpanelKey: 'KEY_MIXPANEL',
  // eslint-disable-next-line no-undef
  exotelNumbers: KEY_EXOTEL_NUMBERS,
  strichKey: 'KEY_STRICH',
};

export default secrets;
